import React, { Component } from 'react'
import {
	CCol,
	CRow,
	CButton,
	CCard,
	CCardBody,
	CCardFooter,
	CFormGroup,
	CForm,
	CLabel,
	CInput,
	CFormText,
	CSelect
} from '@coreui/react'
import withRouter from './withRouter';
import { apiRequest } from "../../services/api-request";
import { Editor } from '@tinymce/tinymce-react';
import "./dateStyles.css";

class edit extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showLoader: false,
			dataLoaded: false,
			fields: {
				user_type: [],
				question: ''
			},
			errors: {},
			answer: ''
		};
	}

	componentDidMount() {
		const { id } = this.props.params;
		if (id) {
			this.setState({ showLoader: true });
			apiRequest({
				url: `master/get-faq-details/${id}`,
				method: "GET",
			}).then((res) => {
				this.setState({ showLoader: false });
				if (res.data) {
					let userTypeData = res.data.user_type || [];
					if (typeof userTypeData === 'string') {
						userTypeData = [userTypeData];
					}
					this.setState({
						fields: {
							user_type: userTypeData,
							question: res.data.question || ''
						},
						answer: res.data.answer || '',
						dataLoaded: true
					});
				} else {
					this.setState({ dataLoaded: true });
				}
			}).catch((err) => {
				this.setState({ showLoader: false, dataLoaded: true });
				console.error("Error fetching faq details:", err?.response?.data?.message || err.message);
				alert(err?.response?.data?.message || "Failed to fetch faq details");
			});
		}
	}

	handleCancel() {
		this.props.navigate('/faq/view');
	}

	handleChange(field, e) {
		let fields = this.state.fields
		if (field === 'answer') {
			fields[field] = e;
		}
		else if (e.target.multiple) {
			let value = Array.from(e.target.selectedOptions, option => option.value);
			fields[field] = value;
			this.setState({ fields })
		}
		else {
			fields[field] = e.target.value;
			this.setState({ fields })
		}
	}

	validation() {
		let fields = this.state.fields;
		let errors = {};
		let formIsValid = true;

		if (!fields["user_type"] || fields["user_type"].length === 0) {
			formIsValid = false;
			errors["user_type"] = "Please select user type.";
		}
		if (!fields["question"]) {
			formIsValid = false;
			errors["question"] = "Please enter question.";
		}
		if (!this.state.answer) {
			formIsValid = false;
			errors["answer"] = "Please enter answer.";
		}

		this.setState({ errors: errors });
		return formIsValid;
	}

	submit() {
		if (this.validation()) {
			this.setState({ showLoader: true })
			const { id } = this.props.params;
			const payload = {
				...this.state.fields,
				faq_id: id
			};
			apiRequest({
				url: 'master/update-faqs',
				method: "POST",
				data: JSON.stringify(payload)
			}).then((res) => {
				this.setState({ showLoader: false });
				this.handleCancel();
			}).catch((err) => {
				this.setState({ showLoader: false });
				console.error("Error updating faq:", err?.response?.data?.message || err.message);
				alert(err?.response?.data?.message || "Failed to update faq");
			});
		}
	}

	render() {
		return (
			<CRow>
				<div className="loader-img" style={{ display: this.state.showLoader ? 'block' : 'none' }}></div>
				<CCol xs="12" md="12">
					<CCard>
						<CCardBody>
							<CForm className="form-horizontal">
								<CFormGroup row>
									<CCol md="6">
										<CLabel htmlFor="hf-Status">User Type</CLabel>
										<CSelect custom multiple onChange={this.handleChange.bind(this, 'user_type')} value={this.state.fields.user_type}>
											<option value="LOAN_OFFICER">LOAN OFFICER</option>
											<option value="VETERINARY">VETERINARY</option>
										</CSelect>
										<CFormText className="help-block" style={{ color: 'red' }}>{this.state.errors.user_type}</CFormText>
									</CCol>
									<CCol md="12">
										<CLabel htmlFor="hf-Type">Question</CLabel>
										<CInput type="text" placeholder="Enter question" onChange={this.handleChange.bind(this, 'question')} value={this.state.fields['question']} />
										<CFormText className="help-block" style={{ color: 'red' }}>{this.state.errors['question']}</CFormText>
									</CCol>
									<CCol md="12">
										<CLabel htmlFor="hf-Type">Answer</CLabel>
										{this.state.dataLoaded && (
											<Editor
												initialValue={this.state.answer}
												onEditorChange={this.handleChange.bind(this, 'answer')}
												apiKey="8e5ycymovq2x6x13yevas6ytjx00ghsnsrubpetkfaghkcd0"
												init={{
													selector: 'textarea#file-picker',
													file_picker_types: 'image',
													image_title: true,
													automatic_uploads: true,
													file_picker_callback: function (cb, value, meta) {
														var input = document.createElement('input');
														input.setAttribute('type', 'file');
														input.setAttribute('accept', 'image/*');
														input.onchange = function () {
															var file = this.files[0];

															var reader = new FileReader();
															reader.onload = function () {
																var id = 'blobid' + (new Date()).getTime();
																var blobCache = window.tinymce.activeEditor.editorUpload.blobCache
																var base64 = reader.result.split(',')[1];
																var blobInfo = blobCache.create(id, file, base64);
																blobCache.add(blobInfo);
																cb(blobInfo.blobUri(), { title: file.name });
															};
															reader.readAsDataURL(file);
														};
														input.click();
													},
													height: 500,
													menubar: false,
													plugins: [
														'advlist autolink lists link image charmap print preview anchor',
														'searchreplace visualblocks code fullscreen',
														'insertdatetime media table paste code help wordcount',
													],
													toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help | image | code',
												}}
											/>
										)}
										<CFormText className="help-block" style={{ color: 'red' }}>{this.state.errors['answer']}</CFormText>
									</CCol>
								</CFormGroup>
							</CForm>
						</CCardBody>
						<CCardFooter>
							<CButton color="primary" className="px-4" onClick={this.submit.bind(this)}>Update</CButton>{' '}
							<CButton color="danger" className="px-4" onClick={this.handleCancel.bind(this)}>Cancel</CButton>
						</CCardFooter>
					</CCard>
				</CCol>
			</CRow>
		)
	}
}

export default withRouter(edit);
